// extracted by mini-css-extract-plugin
export default {"myTabs":"tabs_myTabs__CK-lZ","badge":"tabs_badge__zZ2gc","badge-yellow":"tabs_badge-yellow__AyBea","badge-green":"tabs_badge-green__JBFgE","badge-red":"tabs_badge-red__6nbeN"};